import { BuyVipDialog } from "@/components/Vip";
import { PIN_MATERIAL_STATUS } from "@/constants/pinMaterialStatus";
import { useMemoizedFn } from "ahooks";
import { Button } from "antd";
import styles from "./index.module.less";

/**
 * 素材下载
 * */
export default function PurePinDownload({ pin }) {
  const onClick = useMemoizedFn(async () => {
    BuyVipDialog.open({
      isGdDialog: true,
      source_location: "获取商用授权",
    });
  });

  // 判断是否是素材、素材状态、素材类型
  if (
    pin?.file_material?.status === PIN_MATERIAL_STATUS.AVAILABLE &&
    pin?.file_material?.material_category !== "其他"
  ) {
    return (
      <Button
        className={styles.download}
        data-gd-click="button_click"
        data-button-name="素材卡片-获取商业授权"
        onClick={onClick}
      >
        获取商业授权
      </Button>
    );
  }

  return null;
}
